import { render, staticRenderFns } from "./ModuleCategory.vue?vue&type=template&id=9ab4bdf4&scoped=true"
import script from "./ModuleCategory.vue?vue&type=script&lang=js"
export * from "./ModuleCategory.vue?vue&type=script&lang=js"
import style0 from "./ModuleCategory.vue?vue&type=style&index=0&id=9ab4bdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab4bdf4",
  null
  
)

export default component.exports